import { createSlice } from '@reduxjs/toolkit';
import { fetchUserSession, fetchUser } from './features';

const loadFromStorage = () => {
  try {
    return JSON.parse(localStorage.getItem('user')) || null;
  } catch {
    return null;
  }
};

const persistUser = (updatedUser) => {
  try {
    const stored = loadFromStorage() || {};
    localStorage.setItem(
      'user',
      JSON.stringify({
        ...stored,
        user: updatedUser
      })
    );
  } catch (e) {
    console.error('[UserSession] Failed to persist user to localStorage:', e);
  }
};

const userData = loadFromStorage();

const initialState = {
  user: userData?.user ?? null,
  accessToken: userData?.accessTokenJwt ?? null,
  role: userData?.user?.role ?? null,
  limit: userData?.user?.limit ?? null,
  analysis: userData?.user?.analysis ?? null,
  showTutorial: userData?.user?.showTutorial ?? null,
  flag: null,
  isLoading: true,
  isError: false,
  notFound: false,
};

export const UserSession = createSlice({
  name: 'userSession',
  initialState,

  reducers: {
    updateUser: (state, action) => {
      state.user = action.payload;
      persistUser(action.payload);
    },

    updateUserAnalysisCount: (state, action) => {
      state.analysis = action.payload;
    },

    updateShowTutorial: (state, action) => {
      state.showTutorial = action.payload;
    },

    updateFlag: (state, action) => {
      state.flag = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchUserSession.fulfilled, (state, { payload }) => {
        state.user = payload.user;
        state.role = payload.user?.role;
        state.accessToken = payload.accessTokenJwt;
        state.isLoading = false;
        state.isError = false;
        state.notFound = false;
      })
      .addCase(fetchUserSession.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.notFound = false;
      })
      .addCase(fetchUserSession.rejected, (state) => {
        state.notFound = true;
        state.isLoading = false;
        state.isError = true;
      })

      .addCase(fetchUser.fulfilled, (state, { payload }) => {
        state.user = payload?.user ?? null;
        state.role = payload?.user?.role ?? null;
        state.limit = payload?.user?.limit ?? null;
        state.analysis = payload?.user?.analysis ?? null;
        state.accessToken = payload?.accessTokenJwt ?? null;
        state.showTutorial = payload?.user?.showTutorial ?? null;
        state.isLoading = false;
        state.isError = false;
        state.notFound = false;
      })
      .addCase(fetchUser.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.notFound = false;
      })
      .addCase(fetchUser.rejected, (state) => {
        state.user = null;
        state.accessToken = null;
        state.limit = null;
        state.analysis = null;
        state.showTutorial = null;
        state.isLoading = false;
        state.isError = true;
        state.notFound = false;
      });
  },
});


export default UserSession.reducer;

export const {
  updateUser,
  updateUserAnalysisCount,
  updateShowTutorial,
  updateFlag,
} = UserSession.actions;

export const UserSessionSelector = (state) => state.userSession;
